import { CartSwitcher } from "./cart-switcher";
import { ModeToggle } from "./mode-toggle";

import { useIsClient } from "usehooks-ts";
import NotificationBell from "./notification-bell-dialog";
import { cn } from "@/lib/utils";
import { DashboardLink } from "./dashboard-link";
import { SiteMainNav } from "./site-main-nav";
import Link from "next/link";
import { useRouter } from "next/router";

export default function SiteHeader({ className }: any) {
  const isClient = useIsClient();
  const { locale } = useRouter();

  return (
    <header
      id="custom-header"
      className={cn(
        "sticky top-0 z-50 w-full bg-background/0 backdrop-blur supports-[backdrop-filter]:bg-background/0 print:hidden overflow-hidden h-20 md:h-min",
      )}
    >
      <div className="flex items-center h-12 px-2">
        <SiteMainNav />
        {/* {isClient && <MobileNav events={events} />} */}
        {isClient && (
          <nav className="flex items-center justify-end w-full gap-0 ">
            {/* <CommandMenu /> */}

            <DashboardLink />

            <CartSwitcher />
            <NotificationBell />

            <ModeToggle />
          </nav>
        )}
      </div>
      <div className=" w-full flex flex-row ml-4 md:hidden gap-0">
        <Link
          href={
            "https://tunis.events/" + (locale == "fr" ? locale : "") + "/cinema"
          }
          className="flex items-center mr-4 space-x-2"
        >
          <div className="flex items-center transition-opacity duration-200 opacity-60 hover:opacity-100">
            <span className=" font-medium text-[15px] sm:block">/cinema</span>
          </div>
        </Link>
        <Link
          href={
            "https://tunis.events/" +
            (locale == "fr" ? locale : "") +
            "/artists"
          }
          className="flex items-center mr-4 space-x-2"
        >
          <div className="flex items-center transition-opacity duration-200 opacity-60 hover:opacity-100">
            <span className=" font-medium text-[15px] sm:block">/artistes</span>
          </div>
        </Link>
        <Link
          href={
            "https://tunis.events/" + (locale == "fr" ? locale : "") + "/brands"
          }
          className="flex items-center mr-4 space-x-2"
        >
          <div className="flex items-center transition-opacity duration-200 opacity-60 hover:opacity-100">
            <span className=" font-medium text-[15px] sm:block">
              /collectifs
            </span>
          </div>
        </Link>
        <Link
          href={
            "https://tunis.events/" + (locale == "fr" ? locale : "") + "/labels"
          }
          className="flex items-center mr-4 space-x-2"
        >
          <div className="flex items-center transition-opacity duration-200 opacity-60 hover:opacity-100">
            <span className=" font-medium text-[15px] sm:block">/labels</span>
          </div>
        </Link>
        <Link
          href={
            "https://tunis.events/" + (locale == "fr" ? locale : "") + "/places"
          }
          className="flex items-center mr-4 space-x-2"
        >
          <div className="flex items-center transition-opacity duration-200 opacity-60 hover:opacity-100">
            <span className=" font-medium text-[15px] sm:block">/lieux</span>
          </div>
        </Link>
        <Link
          href="https://codebar.tunis.events/"
          className="flex items-center mr-4 space-x-2"
          target="_blank"
        >
          <div className="flex items-center transition-opacity duration-200 opacity-60 hover:opacity-100">
            <span className=" font-medium text-[15px] sm:block">/play</span>
          </div>
        </Link>
      </div>
    </header>
  );
}
